export default __webpack_public_path__ + "static/media/Mark-Medium.v1.f82f050f.woff";